<template>
    <div>

    </div>
</template>

<script>
export default {
  name: 'functionality-raports',
  methods: {

  },
  created () {

  }
}
</script>
